import script from "./UPaymentsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPaymentsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./UPaymentsHeader.vue?vue&type=style&index=0&id=13883de6&lang=css"

const __exports__ = script;

export default __exports__